
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import { Devotional } from "@/data/devotionals";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";

interface PreviousDevotionalsProps {
  devotionals: Devotional[];
}

export const PreviousDevotionals = ({ devotionals }: PreviousDevotionalsProps) => {
  const navigate = useNavigate();

  const handleDevotionalClick = (date: string) => {
    // Use parseISO for consistent date handling across devices
    const devotionalDate = parseISO(date);
    navigate(`/devotional/${format(devotionalDate, 'yyyy-MM-dd')}`);
  };

  if (!devotionals.length) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="text-xl font-serif font-semibold text-sage-800 mb-4">Previous Devotionals</h3>
      <div className="space-y-3">
        {devotionals.map((devotional, index) => {
          const devotionalDate = parseISO(devotional.date);

          return (
            <Card key={index} className="p-4 hover:bg-sage-50 transition-colors">
              <Button
                variant="ghost"
                className="w-full flex justify-between items-center text-left"
                onClick={() => handleDevotionalClick(devotional.date)}
              >
                <div>
                  <p className="text-lg font-serif text-sage-800">{devotional.topic}</p>
                  <p className="text-sage-600">{format(devotionalDate, 'MMMM d, yyyy')}</p>
                </div>
                <ChevronRight className="text-sage-500" />
              </Button>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
